'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _glamor = require('glamor');

var _reactRedux = require('react-redux');

var _billing = require('redux/modules/billing');

var _Table = require('@quixeltools/quixel-ui-library/dist/components/common/website/Table');

var _Table2 = _interopRequireDefault(_Table);

var _Button = require('@quixeltools/quixel-ui-library/dist/components/common/essentials/Button');

var _Button2 = _interopRequireDefault(_Button);

var _TextButton = require('@quixeltools/quixel-ui-library/dist/components/common/essentials/TextButton');

var _TextButton2 = _interopRequireDefault(_TextButton);

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

var _utils = require('../../utils');

var _polyfluid = require('@quixeltools/quixel-ui-library/dist/utils/polyfluid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tableSection = (0, _glamor.css)((0, _polyfluid.polyfluid)({
  marginTop: {
    smallMedium: 2.578,
    large: [2.578, 3.4375]
  }
}));

var title = (0, _glamor.css)({
  color: _css.colors.white,
  fontWeight: 300
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    smallMedium: 1.6875,
    large: [1.6875, 2.25]
  },
  marginBottom: {
    smallMedium: 1.6875,
    large: [1.6875, 2.25]
  }
}));

var table = (0, _glamor.css)({
  '& th': { width: '25%' },
  '& tbody': (0, _glamor.css)({
    color: _css.colors.white
  }, (0, _polyfluid.polyfluid)({
    fontSize: {
      smallMedium: 1,
      large: [1, 1.125]
    }
  })),
  '& tbody button': (0, _polyfluid.polyfluid)({
    fontSize: {
      smallMedium: 1,
      large: [1, 1.125]
    }
  })
});

var loadMore = (0, _glamor.css)({
  display: 'block',
  marginTop: (0, _css.unitRem)(2)
});

var UserBilling = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loadingBilling: state.billing.loadingBilling,
    pages: state.billing.pages,
    currentPage: state.billing.currentPage
  };
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(UserBilling, _React$Component);

  function UserBilling(props) {
    (0, _classCallCheck3.default)(this, UserBilling);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserBilling.__proto__ || (0, _getPrototypeOf2.default)(UserBilling)).call(this, props));

    _this.loadMore = _this.loadMore.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(UserBilling, [{
    key: 'loadMore',
    value: function loadMore() {
      var _props = this.props,
          currentPage = _props.currentPage,
          pages = _props.pages,
          dispatch = _props.dispatch;

      if (currentPage < pages) {
        var nextPage = currentPage + 1;
        dispatch((0, _billing.loadBillingData)(nextPage, true));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          billing = _props2.billing,
          currentPage = _props2.currentPage,
          pages = _props2.pages,
          loadingBilling = _props2.loadingBilling;

      var isLastPage = currentPage === pages;

      var invoiceType = _ramda2.default.cond([[_ramda2.default.equals('subscription-plan'), _ramda2.default.always('Subscription fee')], [_ramda2.default.equals('subscription-upgrade'), _ramda2.default.always('Subscription upgrade fee')], [_ramda2.default.equals('pack-payment'), _ramda2.default.always('Pack payment')], [_ramda2.default.equals('refill-subscription'), _ramda2.default.always('Top-up')]]);
      var invoiceDate = function invoiceDate(date) {
        return (0, _moment2.default)(date).format('MMM DD, YYYY');
      };
      var invoicePayment = _utils.prettyDollars;

      var entries = billing && billing.length > 0 ? billing.map(function (invoice) {
        return [_react2.default.createElement(_TextButton2.default, { className: (0, _glamor.css)({ padding: '0 0 ' + (0, _css.unitRem)(0.0835) + ' 0' }), label: invoice.invoiceNumber, mode: 'white-underlined', onClick: function onClick(e) {
            e.preventDefault();_this2.props.dispatch((0, _billing.loadInvoice)(invoice.invoiceURL));
          } }), invoiceDate(invoice.transactionResultAt), invoiceType(invoice.type), invoicePayment(invoice.amount)];
      }) : [];

      return _react2.default.createElement(
        'section',
        { className: tableSection },
        _react2.default.createElement(
          'h1',
          { className: title },
          'Billing History'
        ),
        entries.length > 0 ? _react2.default.createElement(_Table2.default, {
          className: table,
          columnTitles: ['Invoice NR', 'Invoice Date', 'Invoice Type', 'Payment'],
          entries: entries
        }) : _react2.default.createElement(
          'div',
          null,
          'No billing history found'
        ),
        !isLastPage && entries.length > 0 && _react2.default.createElement(_Button2.default, {
          className: loadMore,
          label: 'Load More',
          mode: 'primary',
          loading: loadingBilling,
          onClick: this.loadMore })
      );
    }
  }]);
  return UserBilling;
}(_react2.default.Component)) || _class);
exports.default = UserBilling;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserBilling/UserBilling.jsx
// module id = 2675
// module chunks = 0